// extracted by mini-css-extract-plugin
export var active = "W1PCBfGjSnPvgmHDHgyS";
export var customTitle2 = "Dg55VdWQNjm7fbtGXDKg";
export var destructive = "JqPQLXBQDGAQ1ai95avv";
export var focusVisible = "S9he_EVqQVtmBHJwSeFQ";
export var fullWidth = "DbOJlwouzTq11ksmW4eU";
export var ghost = "SZ54o25lgxa67nw5Uasn";
export var icon = "JtE2_Rcr7hTA1o9T_p_9";
export var iconPlaceholder = "dkCcFokr6SFLJ38Xkxsn";
export var large = "dN_6bcS2xUlqDpEruOlV";
export var loading = "RiszzqsTDg1xQu4HqVQo";
export var medium = "UT13p9v7wBqGwjy7ly2Y";
export var primary = "CjdPfWCRdgHSvXKrYKQv";
export var root = "fc1iDuYuNynlgKmz0rM7";
export var secondary1 = "vr8QOfcERGqvmypNjEYE";
export var secondary2 = "VtrKlgUC5WH2nMk2pi5Z";
export var secondary3 = "CzNDVpv49V1jlyw0gEfq";
export var small = "ohy7PufIxCrDeQ4XiZIG";
export var spinner = "A513SvF09NS9s18LcFg6";
export var tertiary = "tFHmM2oM1zW2mK39S4sw";
export var tertiaryDestructive = "Bq1j3DK6TR8EUR9UzidN";
export var text = "foQytmZdjkOwM03WNn0w";
export var xLarge = "tUc6RZpYLcjIh13LUcmg";